import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Row, Col, Card, CardBody, Button, Spinner,
  FormGroup, Label, Input, CardHeader, FormFeedback,
} from 'reactstrap'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import DeleteRecordByAdmin from '../../components/Modal/DeleteRecordByAdmin'
import MaskedInput from '../../components/Template/Input/MaskedInput'
import Select from '../../components/Template/Input/Select'
import DataTable from '../../components/Template/Table/DataTable'
import oikosApi from '../../services/oikos'
import { notifyError, notifySuccess } from '../../utils/notify'
import { yesOrNot } from '../../utils/types/yesOrNot'
import {
  getDepartmentTypes, getCityTypes, getGenderTypes, getMaritalStatusTypes,
  getBloodTypes, getStateTypes, getLanguageTypes, getSectorTypes,
} from '../../store/ducks/types'
import { getIndividuals } from '../../store/ducks/admin'

class PhysicalPerson extends Component {
  constructor(props) {
    super(props)
    this.state = {
      person: {},

      addPersonModalIsOpen: false,
      addPersonIsLoading: false,

      editPersonModalIsOpen: false,
      editPersonIsLoading: false,

      deleteRecordModalIsOpen: false,
      deleteRecordId: null,
      deleteRecordName: '',
    }
  }

  componentDidMount() {
    const {
      getDepartmentTypes, getCityTypes, getGenderTypes, getMaritalStatusTypes,
      getBloodTypes, getStateTypes, getLanguageTypes, getSectorTypes, getIndividuals,
    } = this.props

    getIndividuals()
    getDepartmentTypes()
    getCityTypes()
    getGenderTypes()
    getMaritalStatusTypes()
    getBloodTypes()
    getStateTypes()
    getLanguageTypes()
    getSectorTypes()
  }

  toggleModal = (type) => {
    const {
      addPersonIsLoading, editPersonIsLoading,
      addPersonModalIsOpen, editPersonModalIsOpen,
    } = this.state

    if (addPersonIsLoading || editPersonIsLoading) {
      return null
    }

    if (type === 'add') {
      this.setState(prevState => ({
        addPersonModalIsOpen: !prevState.addPersonModalIsOpen,
      }))

      if (addPersonModalIsOpen) this.setState({ person: null })
    } else if (type === 'edit') {
      this.setState(prevState => ({
        editPersonModalIsOpen: !prevState.editPersonModalIsOpen,
      }))

      if (editPersonModalIsOpen) this.setState({ person: null })
    }

    return null
  }

  handleAddPersonSubmit = async () => {
    const { person } = this.state

    if (!person.pf_nome) person.pf_nomeInvalid = true
    if (!person.pf_sobrenome) person.pf_sobrenomeInvalid = true
    if (!person.pf_nomeExibicao) person.pf_nomeExibicaoInvalid = true

    if (person.pf_nome && person.pf_sobrenome && person.pf_nomeExibicao) {
      try {
        this.setState({ addPersonIsLoading: true })

        delete person.pf_nomeInvalid
        delete person.pf_sobrenomeInvalid
        delete person.pf_nomeExibicaoInvalid

        const body = {
          action: 'insert',
          table: 'pf',
          data: {
            ...person,
            pf_dtNasc: person.pf_dtNasc ? moment(person.pf_dtNasc).format('YYYY-MM-DD') : undefined,
            sexo_id: person.sexo_id ? person.sexo_id.value : undefined,
            estCiv_id: person.estCiv_id ? person.estCiv_id.value : undefined,
            tpSangue_id: person.tpSangue_id ? person.tpSangue_id.value : undefined,
            pf_arrais: person.pf_arrais ? person.pf_arrais.value : undefined,
            uf_id: person.uf_id ? person.uf_id.value : undefined,
            mun_id: person.mun_id ? person.mun_id.value : undefined,
            dpto_id: person.dpto_id ? person.dpto_id.value : undefined,
            pf_gerente: person.pf_gerente ? person.pf_gerente.value : undefined,
            pf_idiomas: person.pf_idiomas || undefined,
          },
        }

        console.tron.log('body handleAddPersonSubmit', body)

        const res = await oikosApi.post('/', body)

        console.tron.log('res handleAddPersonSubmit', res)

        this.setState({ addPersonIsLoading: false, addPersonModalIsOpen: false })
        notifySuccess('Registro adicionado com sucesso.')
        this.props.getIndividuals()
      } catch (e) {
        this.setState({ addPersonIsLoading: false })
        notifyError('Não foi possível adicionar o registro.')
        console.tron.log('Não foi possível adicionar o registro.', e)
      }
    } else {
      this.setState({ person })
      window.scrollTo(0, 0)
    }
  }

  handleEditPersonSubmit = async () => {
    const { person } = this.state

    if (!person.pf_nome) person.pf_nomeInvalid = true
    if (!person.pf_sobrenome) person.pf_sobrenomeInvalid = true
    if (!person.pf_nomeExibicao) person.pf_nomeExibicaoInvalid = true

    if (person.pf_nome && person.pf_sobrenome && person.pf_nomeExibicao) {
      try {
        this.setState({ editPersonIsLoading: true })

        delete person.pf_nomeInvalid
        delete person.pf_sobrenomeInvalid
        delete person.pf_nomeExibicaoInvalid

        const data = Object.fromEntries(Object.entries(person).filter(([_, v]) => v !== null))

        const body = {
          action: 'update',
          table: 'pf',
          data,
        }

        console.tron.log('body handleEditPersonSubmit', body)

        const res = await oikosApi.post('/', body)

        console.tron.log('res handleEditPersonSubmit', res)

        this.setState({ editPersonIsLoading: false, editPersonModalIsOpen: false })
        notifySuccess('Registro modificado com sucesso.')
        this.props.getIndividuals()
      } catch (e) {
        this.setState({ editPersonIsLoading: false })
        notifyError('Não foi possível modificar o registro.')
        console.tron.log('Não foi possível modificar o registro.', e)
      }
    } else {
      this.setState({ person })
      window.scrollTo(0, 0)
    }
  }

  render() {
    const {
      person,
      addPersonModalIsOpen, addPersonIsLoading,
      editPersonModalIsOpen, editPersonIsLoading,
      deleteRecordModalIsOpen, deleteRecordId, deleteRecordName,
    } = this.state

    const {
      getGenderTypesIsLoading, genderTypes,
      getMaritalStatusTypesIsLoading, maritalStatusTypes,
      getBloodTypesIsLoading, bloodTypes,
      getStateTypesIsLoading, stateTypes,
      getCityTypesIsLoading, cityTypes,
      getDepartmentTypesIsLoading, departmentTypes,
      getLanguageTypesIsLoading, languageTypes,
      getSectorTypesIsLoading, sectorTypes,
    } = this.props.types

    const { getIndividualsIsLoading, individuals } = this.props.admin

    let managers = []
    if (individuals?.length > 0) {
      managers = individuals.map(p => ({
        value: p.pf_id,
        label: p.pf_nomeExibicao,
      }))
    }

    return (
      <>
        {addPersonModalIsOpen && (
          <>
            <Row>
              <Col>
                <h4>
                  Adicionar registro
                </h4>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button color="light" size="sm" onClick={() => this.toggleModal('add')}>
                  <i className="ri-close-fill font-size-16" />
                </Button>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>
                    Informações pessoais
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Nome
                          </Label>
                          <Input
                            invalid={person?.pf_nomeInvalid}
                            value={person?.pf_nome}
                            onChange={e => this.setState({
                              person: {
                                ...person,
                                pf_nome: e.target.value,
                                pf_nomeInvalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Sobrenome
                          </Label>
                          <Input
                            invalid={person?.pf_sobrenomeInvalid}
                            value={person?.pf_sobrenome}
                            onChange={e => this.setState({
                              person: {
                                ...person,
                                pf_sobrenome: e.target.value,
                                pf_sobrenomeInvalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Nome de exibição
                          </Label>
                          <Input
                            invalid={person?.pf_nomeExibicaoInvalid}
                            value={person?.pf_nomeExibicao}
                            onChange={e => this.setState({
                              person: {
                                ...person,
                                pf_nomeExibicao: e.target.value,
                                pf_nomeExibicaoInvalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Sexo
                          </Label>
                          <Select
                            isClearable
                            isLoading={getGenderTypesIsLoading}
                            isDisabled={getGenderTypesIsLoading || !genderTypes}
                            options={genderTypes}
                            value={genderTypes?.filter(t => t.value === person?.sexo_id)}
                            onChange={e => this.setState({ person: { ...person, sexo_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            RG
                          </Label>
                          <Input
                            value={person?.pf_rg}
                            onChange={e => this.setState({ person: { ...person, pf_rg: e.target.value } })}
                            maxLength={10}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CPF
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCpf = el}
                            mask="000.000.000-00"
                            lazy={false}
                            value={person?.pf_cpf?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_cpf: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Estado civil
                          </Label>
                          <Select
                            isClearable
                            isLoading={getMaritalStatusTypesIsLoading}
                            isDisabled={getMaritalStatusTypesIsLoading || !maritalStatusTypes}
                            options={maritalStatusTypes}
                            value={maritalStatusTypes?.filter(t => t.value === person?.estCiv_id)}
                            onChange={e => this.setState({ person: { ...person, estCiv_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Data de nascimento
                          </Label>
                          <DatePicker
                            placeholderText="__/__/_____"
                            locale="pt-BR"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            maxDate={new Date()}
                            selected={person?.pf_dtNasc ? moment(person.pf_dtNasc).toDate() : null}
                            onChange={date => this.setState({ person: { ...person, pf_dtNasc: date } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Tipo sanguíneo
                          </Label>
                          <Select
                            isClearable
                            isLoading={getBloodTypesIsLoading}
                            isDisabled={getBloodTypesIsLoading || !bloodTypes}
                            options={bloodTypes}
                            value={bloodTypes?.filter(t => t.value === person?.tpSangue_id)}
                            onChange={e => this.setState({ person: { ...person, tpSangue_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Tipo da CNH
                          </Label>
                          <Input
                            value={person?.pf_tpCnh}
                            onChange={e => this.setState({ person: { ...person, pf_tpCnh: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Arrais
                          </Label>
                          <Select
                            isClearable
                            options={yesOrNot}
                            value={yesOrNot.filter(t => t.value === (person?.pf_arrais ? person.pf_arrais : null))}
                            onChange={e => this.setState({ person: { ...person, pf_arrais: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Plano de saúde
                          </Label>
                          <Input
                            value={person?.pf_segSaude}
                            onChange={e => this.setState({ person: { ...person, pf_segSaude: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CTPS
                          </Label>
                          <Input
                            value={person?.pf_ctps}
                            onChange={e => this.setState({ person: { ...person, pf_ctps: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Contato
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Email profissional
                          </Label>
                          <Input
                            value={person?.pf_emailProf}
                            onChange={e => this.setState({ person: { ...person, pf_emailProf: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Celular profissional
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCelProf = el}
                            mask="(00) 00000-0000"
                            lazy={false}
                            value={person?.pf_celProf?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_celProf: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone fixo profissional
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputTelProf = el}
                            mask="(00) 0000-0000"
                            lazy={false}
                            value={person?.pf_telFixoProf?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_telFixoProf: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Ramal
                          </Label>
                          <Input
                            value={person?.pf_telRamal}
                            onChange={e => this.setState({ person: { ...person, pf_telRamal: Number(e?.target?.value) } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Email particular
                          </Label>
                          <Input
                            value={person?.pf_emailPart}
                            onChange={e => this.setState({ person: { ...person, pf_emailPart: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Celular particular
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCelPart = el}
                            mask="(00) 00000-0000"
                            lazy={false}
                            value={person?.pf_celPart?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_celPart: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone fixo particular
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputTelPart = el}
                            mask="(00) 0000-0000"
                            lazy={false}
                            value={person?.pf_telFixoPart?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_telFixoPart: value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Endereço
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Logradouro
                          </Label>
                          <Input
                            value={person?.pf_endLogr}
                            onChange={e => this.setState({ person: { ...person, pf_endLogr: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Número
                          </Label>
                          <Input
                            value={person?.pf_endNum}
                            onChange={e => this.setState({ person: { ...person, pf_endNum: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Complemento
                          </Label>
                          <Input
                            value={person?.pf_endCompl}
                            onChange={e => this.setState({ person: { ...person, pf_endCompl: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CEP
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCep = el}
                            mask="00000-000"
                            lazy={false}
                            value={person?.pf_cep?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_cep: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            UF
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getStateTypesIsLoading}
                            isDisabled={getStateTypesIsLoading || !stateTypes}
                            options={stateTypes}
                            value={stateTypes?.filter(t => t.value === person?.uf_id)}
                            onChange={e => this.setState({ person: { ...person, uf_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Município
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getCityTypesIsLoading}
                            isDisabled={getCityTypesIsLoading || !cityTypes}
                            options={cityTypes}
                            value={cityTypes?.filter(t => t.value === person?.mun_id)}
                            onChange={e => this.setState({ person: { ...person, mun_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Profissional
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Idiomas
                          </Label>
                          <Select
                            isClearable
                            isSearchable
                            isMulti
                            isLoading={getLanguageTypesIsLoading}
                            isDisabled={getLanguageTypesIsLoading || !languageTypes}
                            options={languageTypes}
                            value={languageTypes?.filter(item => person?.pf_idiomas?.includes(item.value))}
                            onChange={e => this.setState({ person: { ...person, pf_idiomas: e?.map(f => f.value) } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Conselho (nº)
                          </Label>
                          <Input
                            value={person?.pf_numCons}
                            onChange={e => this.setState({ person: { ...person, pf_numCons: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            IBAMA (nº)
                          </Label>
                          <Input
                            value={person?.pf_ibama}
                            onChange={e => this.setState({ person: { ...person, pf_ibama: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Departamento
                          </Label>
                          <Select
                            isClearable
                            isLoading={getDepartmentTypesIsLoading}
                            isDisabled={getDepartmentTypesIsLoading || !departmentTypes}
                            options={departmentTypes}
                            value={departmentTypes?.filter(t => t.value === person?.dpto_id)}
                            onChange={e => this.setState({ person: { ...person, dpto_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Setores
                          </Label>
                          <Select
                            isMulti
                            isClearable
                            isLoading={getSectorTypesIsLoading}
                            isDisabled={getSectorTypesIsLoading || !sectorTypes}
                            options={sectorTypes}
                            value={sectorTypes?.filter(item => person?.pf_setoresId?.includes(item.value))}
                            onChange={e => this.setState({ person: { ...person, pf_setoresId: e?.map(f => f.value) } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Cargo
                          </Label>
                          <Input
                            value={person?.pf_cargo}
                            onChange={e => this.setState({ person: { ...person, pf_cargo: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Gerente
                          </Label>
                          <Select
                            isClearable
                            isLoading={getIndividualsIsLoading}
                            isDisabled={getIndividualsIsLoading || !individuals}
                            options={individuals?.map(p => ({
                              value: p.pf_id,
                              label: p.pf_nomeExibicao,
                            }))}
                            value={managers?.filter(t => t.value === person?.pf_gerente)}
                            onChange={e => this.setState({ person: { ...person, pf_gerente: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Contato de emergência
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Nome
                          </Label>
                          <Input
                            value={person?.pf_nomeContatoEmerg}
                            onChange={e => this.setState({ person: { ...person, pf_nomeContatoEmerg: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone
                          </Label>
                          <Input
                            value={person?.pf_telContatoEmerg}
                            onChange={e => this.setState({ person: { ...person, pf_telContatoEmerg: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Sistemas internos
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            ID SEGI
                          </Label>
                          <Input
                            value={person?.pf_segi}
                            onChange={e => this.setState({ person: { ...person, pf_segi: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            ID SharePoint
                          </Label>
                          <Input
                            value={person?.pf_sharepointId}
                            onChange={e => this.setState({ person: { ...person, pf_sharepointId: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg={6}>
                        <FormGroup>
                          <Label>
                            ID Graph
                          </Label>
                          <Input
                            value={person?.pf_graphId}
                            onChange={e => this.setState({ person: { ...person, pf_graphId: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <hr className="mt-2 mb-4" />
              </Col>
            </Row>

            <Row>
              <Col className="d-flex justify-content-end">
                <Button
                  type="button"
                  color="primary"
                  className="ml-3"
                  disabled={addPersonIsLoading}
                  onClick={() => this.handleAddPersonSubmit()}
                >
                  Enviar
                  {addPersonIsLoading && (
                    <Spinner size="sm" className="ml-2" />
                  )}
                </Button>
              </Col>
            </Row>
          </>
        )}

        {editPersonModalIsOpen && (
          <>
            <Row>
              <Col>
                <h4>
                  Editar registro
                </h4>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button color="light" size="sm" onClick={() => this.toggleModal('edit')}>
                  <i className="ri-close-fill font-size-16" />
                </Button>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>
                    Informações pessoais
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Nome
                          </Label>
                          <Input
                            invalid={person?.pf_nomeInvalid}
                            value={person?.pf_nome}
                            onChange={e => this.setState({
                              person: {
                                ...person,
                                pf_nome: e.target.value,
                                pf_nomeInvalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Sobrenome
                          </Label>
                          <Input
                            invalid={person?.pf_sobrenomeInvalid}
                            value={person?.pf_sobrenome}
                            onChange={e => this.setState({
                              person: {
                                ...person,
                                pf_sobrenome: e.target.value,
                                pf_sobrenomeInvalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Nome de exibição
                          </Label>
                          <Input
                            invalid={person?.pf_nomeExibicaoInvalid}
                            value={person?.pf_nomeExibicao}
                            onChange={e => this.setState({
                              person: {
                                ...person,
                                pf_nomeExibicao: e.target.value,
                                pf_nomeExibicaoInvalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Sexo
                          </Label>
                          <Select
                            isClearable
                            isLoading={getGenderTypesIsLoading}
                            isDisabled={getGenderTypesIsLoading || !genderTypes}
                            options={genderTypes}
                            value={genderTypes?.filter(t => t.value === person?.sexo_id)}
                            onChange={e => this.setState({ person: { ...person, sexo_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            RG
                          </Label>
                          <Input
                            value={person?.pf_rg}
                            onChange={e => this.setState({ person: { ...person, pf_rg: e.target.value } })}
                            maxLength={10}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CPF
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCpf = el}
                            mask="000.000.000-00"
                            lazy={false}
                            value={person?.pf_cpf?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_cpf: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Estado civil
                          </Label>
                          <Select
                            isClearable
                            isLoading={getMaritalStatusTypesIsLoading}
                            isDisabled={getMaritalStatusTypesIsLoading || !maritalStatusTypes}
                            options={maritalStatusTypes}
                            value={maritalStatusTypes?.filter(t => t.value === person?.estCiv_id)}
                            onChange={e => this.setState({ person: { ...person, estCiv_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Data de nascimento
                          </Label>
                          <DatePicker
                            placeholderText="__/__/_____"
                            locale="pt-BR"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            maxDate={new Date()}
                            selected={person?.pf_dtNasc ? moment(person.pf_dtNasc).toDate() : null}
                            onChange={date => this.setState({ person: { ...person, pf_dtNasc: date } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Tipo sanguíneo
                          </Label>
                          <Select
                            isClearable
                            isLoading={getBloodTypesIsLoading}
                            isDisabled={getBloodTypesIsLoading || !bloodTypes}
                            options={bloodTypes}
                            value={bloodTypes?.filter(t => t.value === person?.tpSangue_id)}
                            onChange={e => this.setState({ person: { ...person, tpSangue_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Tipo da CNH
                          </Label>
                          <Input
                            value={person?.pf_tpCnh}
                            onChange={e => this.setState({ person: { ...person, pf_tpCnh: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Arrais
                          </Label>
                          <Select
                            isClearable
                            options={yesOrNot}
                            value={yesOrNot.filter(t => t.value === (person?.pf_arrais ? person.pf_arrais : null))}
                            onChange={e => this.setState({ person: { ...person, pf_arrais: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Plano de saúde
                          </Label>
                          <Input
                            value={person?.pf_segSaude}
                            onChange={e => this.setState({ person: { ...person, pf_segSaude: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CTPS
                          </Label>
                          <Input
                            value={person?.pf_ctps}
                            onChange={e => this.setState({ person: { ...person, pf_ctps: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Contato
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Email profissional
                          </Label>
                          <Input
                            value={person?.pf_emailProf}
                            onChange={e => this.setState({ person: { ...person, pf_emailProf: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Celular profissional
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCelProf = el}
                            mask="(00) 00000-0000"
                            lazy={false}
                            value={person?.pf_celProf?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_celProf: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone fixo profissional
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputTelProf = el}
                            mask="(00) 0000-0000"
                            lazy={false}
                            value={person?.pf_telFixoProf?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_telFixoProf: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Ramal
                          </Label>
                          <Input
                            value={person?.pf_telRamal}
                            onChange={e => this.setState({ person: { ...person, pf_telRamal: Number(e?.target?.value) } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Email particular
                          </Label>
                          <Input
                            value={person?.pf_emailPart}
                            onChange={e => this.setState({ person: { ...person, pf_emailPart: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Celular particular
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCelPart = el}
                            mask="(00) 00000-0000"
                            lazy={false}
                            value={person?.pf_celPart?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_celPart: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone fixo particular
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputTelPart = el}
                            mask="(00) 0000-0000"
                            lazy={false}
                            value={person?.pf_telFixoPart?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_telFixoPart: value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Endereço
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Logradouro
                          </Label>
                          <Input
                            value={person?.pf_endLogr}
                            onChange={e => this.setState({ person: { ...person, pf_endLogr: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Número
                          </Label>
                          <Input
                            value={person?.pf_endNum}
                            onChange={e => this.setState({ person: { ...person, pf_endNum: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Complemento
                          </Label>
                          <Input
                            value={person?.pf_endCompl}
                            onChange={e => this.setState({ person: { ...person, pf_endCompl: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CEP
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCep = el}
                            mask="00000-000"
                            lazy={false}
                            value={person?.pf_cep?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pf_cep: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            UF
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getStateTypesIsLoading}
                            isDisabled={getStateTypesIsLoading || !stateTypes}
                            options={stateTypes}
                            value={stateTypes?.filter(t => t.value === person?.uf_id)}
                            onChange={e => this.setState({ person: { ...person, uf_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Município
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getCityTypesIsLoading}
                            isDisabled={getCityTypesIsLoading || !cityTypes}
                            options={cityTypes}
                            value={cityTypes?.filter(t => t.value === person?.mun_id)}
                            onChange={e => this.setState({ person: { ...person, mun_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Profissional
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Idiomas
                          </Label>
                          <Select
                            isClearable
                            isSearchable
                            isMulti
                            isLoading={getLanguageTypesIsLoading}
                            isDisabled={getLanguageTypesIsLoading || !languageTypes}
                            options={languageTypes}
                            value={languageTypes?.filter(item => person?.pf_idiomas?.includes(item.value))}
                            onChange={e => this.setState({ person: { ...person, pf_idiomas: e?.map(f => f.value) } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Conselho (nº)
                          </Label>
                          <Input
                            value={person?.pf_numCons}
                            onChange={e => this.setState({ person: { ...person, pf_numCons: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            IBAMA (nº)
                          </Label>
                          <Input
                            value={person?.pf_ibama}
                            onChange={e => this.setState({ person: { ...person, pf_ibama: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Departamento
                          </Label>
                          <Select
                            isClearable
                            isLoading={getDepartmentTypesIsLoading}
                            isDisabled={getDepartmentTypesIsLoading || !departmentTypes}
                            options={departmentTypes}
                            value={departmentTypes?.filter(t => t.value === person?.dpto_id)}
                            onChange={e => this.setState({ person: { ...person, dpto_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Setores
                          </Label>
                          <Select
                            isMulti
                            isClearable
                            isLoading={getSectorTypesIsLoading}
                            isDisabled={getSectorTypesIsLoading || !sectorTypes}
                            options={sectorTypes}
                            value={sectorTypes?.filter(item => person?.pf_setoresId?.includes(item.value))}
                            onChange={e => this.setState({ person: { ...person, pf_setoresId: e?.map(f => f.value) } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Cargo
                          </Label>
                          <Input
                            value={person?.pf_cargo}
                            onChange={e => this.setState({ person: { ...person, pf_cargo: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Gerente
                          </Label>
                          <Select
                            isClearable
                            isLoading={getIndividualsIsLoading}
                            isDisabled={getIndividualsIsLoading || !individuals}
                            options={individuals?.map(p => ({
                              value: p.pf_id,
                              label: p.pf_nomeExibicao,
                            }))}
                            value={managers?.filter(t => t.value === person?.pf_gerente)}
                            onChange={e => this.setState({ person: { ...person, pf_gerente: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Contato de emergência
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Nome
                          </Label>
                          <Input
                            value={person?.pf_nomeContatoEmerg}
                            onChange={e => this.setState({ person: { ...person, pf_nomeContatoEmerg: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone
                          </Label>
                          <Input
                            value={person?.pf_telContatoEmerg}
                            onChange={e => this.setState({ person: { ...person, pf_telContatoEmerg: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Sistemas internos
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            ID SEGI
                          </Label>
                          <Input
                            value={person?.pf_segi}
                            onChange={e => this.setState({ person: { ...person, pf_segi: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            ID SharePoint
                          </Label>
                          <Input
                            value={person?.pf_sharepointId}
                            onChange={e => this.setState({ person: { ...person, pf_sharepointId: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg={6}>
                        <FormGroup>
                          <Label>
                            ID Graph
                          </Label>
                          <Input
                            value={person?.pf_graphId}
                            onChange={e => this.setState({ person: { ...person, pf_graphId: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <hr className="mt-2 mb-4" />
              </Col>
            </Row>

            <Row>
              <Col className="d-flex justify-content-end">
                <Button
                  type="button"
                  color="primary"
                  className="ml-3"
                  disabled={editPersonIsLoading}
                  onClick={() => this.handleEditPersonSubmit()}
                >
                  Enviar
                  {editPersonIsLoading && (
                    <Spinner size="sm" className="ml-2" />
                  )}
                </Button>
              </Col>
            </Row>
          </>
        )}

        {!addPersonModalIsOpen && !editPersonModalIsOpen && (
          <>
            <DeleteRecordByAdmin
              isOpen={deleteRecordModalIsOpen}
              recordId={deleteRecordId}
              recordType="pf"
              recordName={deleteRecordName}
              toggle={() => this.setState({
                deleteRecordModalIsOpen: !deleteRecordModalIsOpen,
              })}
            />

            <Row>
              <Col>
                <h4>
                  Lista
                </h4>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button outline color="primary" onClick={() => this.toggleModal('add')}>
                  Adicionar
                </Button>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardBody className="pb-1">
                    {getIndividualsIsLoading && (
                      <Row>
                        <Col className="d-flex align-items-center justify-content-center py-3">
                          <Spinner size="sm" />
                        </Col>
                      </Row>
                    )}

                    {!getIndividualsIsLoading && individuals && (
                      <DataTable
                        data={{
                          columns: [
                            {
                              label: 'ID',
                              field: 'pf_id',
                            },
                            {
                              label: 'Nome',
                              field: 'pf_nomeExibicao',
                            },
                            {
                              label: 'Email',
                              field: 'pf_emailProf',
                            },
                            {
                              label: 'Ações',
                              field: 'actions',
                            },
                          ],
                          rows: individuals.map(person => ({
                            ...person,
                            actions: (
                              <div>
                                <Button
                                  size="sm"
                                  color="light"
                                  onClick={() => {
                                    this.setState({ person, editPersonModalIsOpen: true })
                                  }}
                                >
                                  <i className="ri-pencil-fill" />
                                </Button>

                                <Button
                                  size="sm"
                                  color="light"
                                  className="ml-2"
                                  onClick={() => this.setState({
                                    deleteRecordModalIsOpen: true,
                                    deleteRecordId: person.pf_id,
                                    deleteRecordName: person.pf_nomeExibicao,
                                  })}
                                >
                                  <i className="ri-delete-bin-6-line" />
                                </Button>
                              </div>
                            ),
                          })),
                        }}
                      />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </>
    )
  }
}

const mapStateToProps = state => ({
  types: state.types,
  admin: state.admin,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getGenderTypes,
  getMaritalStatusTypes,
  getBloodTypes,
  getStateTypes,
  getDepartmentTypes,
  getCityTypes,
  getLanguageTypes,
  getSectorTypes,
  getIndividuals,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(PhysicalPerson)
